import { ComponentProps } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useTranslation } from 'next-i18next';
import { useDMFriendsListQuery } from 'src/hooks/useDirectMessageQuery';
import useUseDMFirstTime from 'src/hooks/useUseDMFirstTime';
import FollowUserCard from './Item';
import FollowMoreCard from './More';
import FollowListSkeleton from './Skeleton';
const Container = styled.div`
  position: relative;

  display: flex;

  ${({
  theme
}) => theme.screenSize.tablet} {
    overflow-x: auto;

    scrollbar-width: none;

    ::-webkit-scrollbar {
      display: none;
    }
  }
`;
const List = styled.ul`
  list-style: none;

  display: flex;
  gap: 8px;

  margin: 0;
  padding: 0;

  ${({
  theme
}) => theme.screenSize.desktop} {
    min-width: 0;
    gap: 0;
    flex: 1;

    flex-direction: column;
    align-items: stretch;
  }
`;

/** overflow-x: scroll 일 때 우측에 가상 패딩 추가 */
const itemStyles = ({
  theme
}: {
  theme: Theme;
}) => css`
  position: relative;

  :last-of-type::after {
    content: '';
    display: block;
    position: absolute;
    right: -16px;
    width: 16px;
    height: 1px;
  }

  ${theme.screenSize.tablet} {
    flex: 0 0 128px;
    max-width: 128px;
  }

  ${theme.screenSize.tablet} {
    padding: 10px 0;
  }
`;
const Item = styled(FollowUserCard)`
  ${itemStyles}
`;
const More = styled(FollowMoreCard)`
  ${itemStyles}

  ${({
  theme
}) => theme.screenSize.desktop} {
    display: none;
  }
`;
const EmptyContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 112px;
  border-radius: 16px;

  background-color: ${({
  theme
}) => theme.color.surface2};
  color: ${({
  theme
}) => theme.color.content8};

  font-size: 14px;
`;
const EmptyMessage = styled.p``;
const THRESHOLD = 5;
type Props = Pick<ComponentProps<'div'>, 'className'>;
const FollowList = (props: Props) => {
  const {
    t
  } = useTranslation();
  const {
    data: {
      follows = []
    } = {}
  } = useDMFriendsListQuery();
  const {
    isLoading
  } = useUseDMFirstTime();
  const showMore = follows.length > THRESHOLD;
  if (isLoading) {
    return <Container {...props}>
        <List>
          <FollowListSkeleton />
        </List>
      </Container>;
  }
  if (follows.length === 0) {
    return <Container {...props}>
        <EmptyContainer>
          <EmptyMessage>{t('follow_list_emptycase_following')}</EmptyMessage>
        </EmptyContainer>
      </Container>;
  }
  return <Container {...props} data-sentry-element="Container" data-sentry-component="FollowList" data-sentry-source-file="index.tsx">
      <List data-sentry-element="List" data-sentry-source-file="index.tsx">
        {follows.slice(0, THRESHOLD).map(followInfo => <Item key={followInfo.followId} followInfo={followInfo} />)}
        {showMore && <More />}
      </List>
    </Container>;
};
export default FollowList;